export default __webpack_public_path__ + "static/media/umbrella.f6e8c739.svg";